<template>
    <div class="main">
        <download-Popup></download-Popup>
        <div class="topFixedWrap" id="topFixed">
            <p class="operamini-tips" v-if="isOperamini">In order to give you a better experience, please download our
                professional APP.</p>
            <downloadheader v-show="downLoadHeaderShow" id="headwrap"></downloadheader>
            <p class="navBread">
                <a href="/matchs" class="match">Match</a>
                <a :href="'/matchs/'+subtitleName" id="matchSubtitJump">{{subtitleName}}</a>
            </p>
            <div class="bannerInformWrap clearfix" id="teamWrap">
                <dl class="bannerLeft">
                    <dt><img class="detailTeamLogo" :src="getImgSrc(idData.team_A_logo)" :alt="idData.team_A_name" v-team-logo></dt>
                    <dd>{{idData.team_A_name}}</dd>
                </dl>
                <div class="bannerCenterWrap">
                    <div class="status_ended" v-if="competeStatus === 'Played'">
                        <p class="competename">{{idData.competition_name}}</p>
                        <div class="scorewrap clearfix">
                            <span class="ml15">{{idData.fs_A}}</span><b class="rowLine"></b><span>{{idData.fs_B}}</span>
                        </div>
                        <p class="time">{{local_month_day}} {{tran12(local_hour_minite)}}</p>
                    </div>
                    <div class="status_playing" v-if="competeStatus === 'Playing'">
                        <p class="competename">{{idData.competition_name}}</p>
                        <div class="scorewrap clearfix">
                            <span class="ml15">{{idData.fs_A}}</span><b class="rowLine"></b><span>{{idData.fs_B}}</span>
                        </div>
                        <p class="live" v-if="idData.livingFlag"><img src="../assets/video/video_arrow.png" alt=""
                                                                      class="play_arrow"><span class="fl">LIVE IN {{idData.minute}}'</span>
                        </p>
                        <p class="unlive" v-if="!idData.livingFlag">{{idData.minute}}'</p>
                    </div>
                    <div class="status_unstart" v-if="competeStatus === 'Fixture'">
                        <p class="competename">{{idData.competition_name}}</p>
                        <p class="vs">VS</p>
                        <div class="unstartTime clearfix">
                            <span class="unstartLive" v-if="idData.livingFlag">LIVE</span><span class="time">{{local_month_day}} {{tran12(local_hour_minite)}}</span>
                        </div>
                    </div>
                    <div class="status_unstart"
                         v-if="competeStatus === 'Postponed'||competeStatus === 'Cancelled'||competeStatus === 'Suspended'">
                        <p class="competename">{{idData.competition_name}}</p>
                        <p class="vs">VS</p>
                        <div class="unstartTime clearfix">
                            <span class="time">{{competeStatus}}</span>
                        </div>
                    </div>
                </div>
                <dl class="bannerRight">
                    <dt><img class="detailTeamLogo" :alt="idData.team_B_name" :src="getImgSrc(idData.team_B_logo)" v-team-logo></dt>
                    <dd>{{idData.team_B_name}}</dd>
                </dl>
            </div>
            <div class="tabWrap">
                <span :class="{'selected':toggleSelect === 'Score'}" v-if="scoreTabInfo" @click="toggle('Score')">Score</span>
                <span :class="{'selected':toggleSelect === 'OverView'}" @click="toggle('OverView')">Overview</span>
                <span :class="{'selected':toggleSelect === 'Analysis'}" @click="toggle('Analysis')">Analysis</span>
                <span :class="{'selected':toggleSelect === 'Odds'}" @click="toggle('Odds')">Odds</span>
            </div>
        </div>
        <div class="contentWrap" id="contentWrap">
            <matchScore :matchId="competeId" :scoreTabInfo="scoreTabInfo" v-if="toggleSelect === 'Score' && scoreTabInfo"></matchScore>
            <match-overview v-show="toggleSelect === 'OverView'" class="tabContent"
                            :matchId="competeId"></match-overview>
            <match-analysis v-show="toggleSelect === 'Analysis'" class="tabContent"
                            :matchId="competeId"></match-analysis>
            <odds v-show="toggleSelect === 'Odds'"></odds>
        </div>
    </div>
</template>
<script type="text/javascript">
    // import Vue from 'vue';
    import downloadheader from '@/components/downloadHeader.vue';
    import navVue from '@/components/nav.vue';
    import downloadPopup from '@/components/downloadPopup.vue';
    import matchScore from '../components/matchScore.vue';
    import matchOverview from '@/components/matchOverview.vue';
    import matchAnalysis from '@/components/matchAnalysis.vue';
    import odds from '@/components/matchDetailOdds/App.vue';
    import messages from '@/lang/matchDetail';
    import axios from 'axios';
    import { record } from '@/util/util.js'

    export default {
        name: 'matchDetail',
        data () {
            return {
                downLoadHeaderShow: true,
                toggleSelect: 'Analysis',
                subtitleName: '',
                competeId: null,
                idUrl: '',
                idData: {},
                idMatchAnalysisUrl: '',
                idMatchOddsUrl: '',
                idMatchOverViewUrl: '',
                competeStatus: '',
                local_month_day: '',
                local_hour_minite: '',
                currentIframeSrc: '',
                isOperamini: false,
                scoreTabInfo: null
            };
        },
        asyncData ({ store, route: { params: { id, language } } }) {
            // 此函数会在组件实例化之前执行，故直接将store,route传入；
            let locale = (language && language.split('-')[0]) || 'en';
            if (id) {
                return Promise.all([
                    store.dispatch('FETCH_MATCH_DETAIL_FORMATION', { matchId: id }), // 获取详情页面部分信息
                    store.dispatch('FETCH_MATCH_OVERVIEW_FORMATION', { matchId: id, locale }), // 获取overview组件需展示的信息
                    store.dispatch('FETCH_MATCH_ANALYSIS_FORMATION', { matchId: id, locale, isJSON: true }), // 获取analysis组件需展示的信息
                    store.dispatch('FETCH_MATCH_ODDS_EURO', { matchId: id }), // 获取odds组件euro需展示的信息
                    store.dispatch('FETCH_MATCH_ODDS_ASIA', { matchId: id }), // 获取odds组件asia需展示的信息
                    store.dispatch('FETCH_MATCH_ODDS_OVER_UNDER', { matchId: id }) // 获取odds组件over_under需展示的信息
                ]);
            } else {
                return Promise.reject('id不存在');
            }
        },
        head () {
            return {
                title: `${this.idData.team_A_name} VS ${this.idData.team_B_name} | ${this.idData.competition_name} | ${this.idData.date_utc} | All Football`,
                meta: [
                    {
                        name: 'description',
                        content: `The live score, overview, odds, lineup, events, technical statistics, match analysis of ${this.idData.competition_name} ${this.idData.team_A_name} vs ${this.idData.team_B_name} at ${this.idData.date_utc}`
                    },
                    {
                        name: 'keywords',
                        content: `${this.idData.competition_name}, ${this.idData.team_A_name}, ${this.idData.team_B_name}`
                    }
                ]
            };
        },
        computed: {
            matchDetailFormation () {
                return this.$store.state.matchDetailStore.matchDetailFormation;
            }
        },
        created: function () {
            let that = this;
            this.competeId = this.$route.params.id;
            this.subtitleName = this.$route.params.subtitle;
            Object.keys(messages).map(locale => this.$i18n.setLocaleMessage(locale, messages[locale]));
            that.idData = that.matchDetailFormation.matchSample || {};
            that.idMatchAnalysisUrl = that.matchDetailFormation.matchAnalysis.url || '';
            that.idMatchOddsUrl = that.matchDetailFormation.matchOdds.url || '';
            that.idMatchOverViewUrl = that.matchDetailFormation.matchSK.url || '';
            that.competeStatus = that.idData.status || '';
            let utcTime = that.idData.start_play || '';
            that.local_month_day = that.formatData(utcTime).local_Month_Day || '';
            that.local_hour_minite = that.formatData(utcTime).local_hms || '';
            if (that.competeStatus === 'Played' || that.competeStatus === 'Playing') {
                that.currentIframeSrc = that.idMatchOverViewUrl;
                that.toggleSelect = 'OverView';
            } else if (that.competeStatus === 'Fixture') {
                that.currentIframeSrc = that.idMatchAnalysisUrl + '?m_station';
                that.toggleSelect = 'Analysis';
            }
        },
        updated: function () {
            let utilObj = require('@/util/util.js');
            utilObj.lazyload('teamWrap', 'detailTeamLogo');
        },
        mounted: function () {
            let utilObj = require('@/util/util.js');
            document.body.scrollTop = 0;
            this.isOperamini = utilObj.checkOperamini();
            utilObj.timeForInOut();
            this.checkScoreTab()
        },
        methods: {
            checkScoreTab() {
                let sportdataApiBaseUrl = 'https://sportdata-v2.allfootballapp.com'
                if (process.env.NODE_ENV === 'development' || location.hostname.startsWith('beta')) {
                    sportdataApiBaseUrl = 'https://beta-sportdata-v2.allfootballapp.com'
                }
                let matchId = Number(this.competeId) - 50000000
                axios.get(`${sportdataApiBaseUrl}/soccer/biz/match/score_tab?match_id=${matchId}&app=af`).then(res => {
                    if (res.data && res.data.score_tab) {
                        this.scoreTabInfo = res.data
                        record(`msite/matchDetail?action=showScoreTab&matchId=${matchId}`)
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            // 转换成12小时制方法
            tran12 (time) {
                let timeArr = time.split(':');
                let result = '';
                if (timeArr[0] > 12) {
                    result = (timeArr[0] - 12) + ':' + timeArr[1] + ' FM';
                } else {
                    result = timeArr[0] + ':' + timeArr[1] + ' AM';
                }
                return result;
            },
            toggle: function (toggleName) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                if (toggleName === 'OverView') {
                    this.toggleSelect = 'OverView';
                } else if (toggleName === 'Analysis') {
                    this.toggleSelect = 'Analysis';
                } else if (toggleName === 'Odds') {
                    this.toggleSelect = 'Odds';
                } else if (toggleName === 'Score') {
                    this.toggleSelect = 'Score';
                }
                let matchId = Number(this.competeId) - 50000000
                record(`msite/matchDetail?action=changeTab&tab=${this.toggleSelect}&matchId=${matchId}`)
            },
            formatData: function (gmtDate) {
                let date = new Date(gmtDate.replace(/-/g, '/')).getTime(); // 获取UTC时间戳
                let diffMin = new Date().getTimezoneOffset(); // 返回UTC时间和当前计算机上的时间之间相差的分钟数。utc-当地=差分钟数;
                let localDate = new Date(date - diffMin * 60 * 1000); // 获取当地时间
                let localMonth = localDate.getMonth() + 1;
                if (localMonth < 10) {
                    localMonth = '0' + localMonth;
                }
                let localTimeDetail = ('' + localDate).split(' ');
                let localMonthDay = localMonth + '-' + localTimeDetail[2];
                return {
                    local_Month_Day: localMonthDay,
                    local_hms: localTimeDetail[4].slice(0, 5)
                };
            }
        },
        components: {
            downloadheader, navVue, downloadPopup, matchOverview, matchAnalysis, odds, matchScore
        }
    };
</script>
<style lang="less" scoped>
    .topFixedWrap {
        width: 100%;
        position: fixed;
        top: 0;
        z-index: 999;
    }

    //Android
    .tab-box-fixed {
        position: fixed;
        z-index: 10;
        top: 0;
        left: 0;
    }

    //iOS
    .tab-box-sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 10;
    }

    .navBread {
        width: 100%;
        height: 2.4rem;
        background: #16b13a;
        color: #fff;
        line-height: 2.4rem;
    }

    .navBread a {
        padding: 0 1rem;
        text-decoration: none;
        color: #fff;
        font-size: .8rem;
    }

    .navBread .match {
        font-size: 1rem;
        display: inline-block;
        height: 1.2rem;
        line-height: 1.2rem;
        border-right: 0.05rem solid #119730;
    }

    .bannerInformWrap {
        width: 100%;
        height: 7.4rem;
        overflow: hidden;
        background: url(../assets/match/videoMatchBannerBg.jpg) no-repeat;
        background-size: cover;
    }

    .bannerInformWrap dl {
        width: 32%;
        float: left;
        margin-top: 2.2rem;
    }

    .bannerCenterWrap {
        width: 36%;
        height: 5rem;
        float: left;
        padding: 1.1rem 0rem;
        color: #fff;
        font-size: .68rem;
        text-align: center;
    }

    .bannerInformWrap dl dt, .bannerInformWrap dl dd {
        width: 5rem;
        margin: 0 auto;
        color: #fff;
        font-size: .7rem;
        text-align: center;
    }

    .bannerInformWrap dl dd {
        width: 3.2rem !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 auto;
    }

    .bannerInformWrap dl dt img {
        width: 2.7rem;
        height: 2.7rem;
        display: block;
        margin: 0 auto 1rem;
    }

    .status_ended .scorewrap span {
        width: 2.1rem;
        height: 2.1rem;
        overflow: hidden;
        display: inline-block;
        background: rgba(255, 255, 255, 0.1);
        font-size: 2rem;
        float: left;
        border-radius: .1rem;
        text-align: center;
        line-height: 2rem;
    }

    .rowLine {
        float: left;
        width: .7rem;
        height: .2rem;
        display: inline-block;
        background: #fff;
        overflow: hidden;
        margin: 1rem 1rem 0;
    }

    .competename {
        margin-bottom: 0.6rem;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .time {
        font-size: 0.7rem;
        color: #fff;
        text-align: center;
    }

    .scorewrap {
        margin-bottom: 1.2rem;
    }

    .status_playing .scorewrap span {
        width: 2.2rem;
        height: 2.2rem;
        overflow: hidden;
        display: inline-block;
        background: rgba(255, 255, 255, 0.1);
        font-size: 2rem;
        float: left;
        border-radius: 0.2rem;;
        color: #16b13a;
        line-height: 2.2rem;
    }

    .status_playing .rowLine {
        background: #16b13a;
    }

    .status_playing .live {
        width: 6rem;
        height: 1rem;
        background: #16bc3a;
        border-radius: 0.02666667rem;
        display: block;
        color: #fff;
        font-size: 0.68rem;
        line-height: 1rem;
        margin: 0 auto;
    }

    .play_arrow {
        margin: 0.25rem 0.4rem 0 1rem;
        width: 0.3rem;
        height: 0.4rem;
        float: left;
    }

    .unlive {
        color: #16b13a;
        font-size: 0.8rem;
    }

    .status_unstart {
        font-size: 0.8rem;
    }

    .status_unstart .vs {
        font-size: 1rem;
        margin-bottom: .9rem;
        padding-top: 0.8rem;
    }

    .unstartTime {
        height: 1rem;
        line-height: 1rem;
        overflow: hidden;
    }

    .unstartLive {
        width: 2.4rem;
        height: 0.8rem;
        line-height: 0.8rem;
        display: inline-block;
        color: #16bc3a;
        font-size: 0.6rem;
        border: 1px solid #16bc3a;
        border-radius: 0.02666667rem;
        float: left;
        margin: 0 0.2rem 0 0.4rem;
        transform: scale(0.7);
        position: relative;
        left: 0.7rem;
        top: 0.1rem;
    }

    .unstartTime time {
        float: left;
        font-size: 0.68rem;
    }

    .tabWrap {
        display: flex;
        align-items: center;
        border-bottom: .1rem solid #eff1f4;
        width: 100%;
        height: 2.4rem;
        line-height: 2.4rem;
        background: #fff;
    }

    .tabWrap span {
        // width: 33.3333%;
        // display: inline-block;
        flex: 1;
        height: 2.4rem;
        line-height: 2.4rem;
        float: left;
        text-align: center;
        color: #606369;
        font-size: .9rem;
        box-sizing: border-box;
    }

    .tabWrap span.selected {
        border-bottom: .1rem solid #16bc3a;
        color: #16bc3a;
        position: relative;
    }

    .contentWrap {
        position: relative;
        top: 5rem+2.4rem+2.4rem+7.4rem;
        font-size: 12px;
    }

    .contentWrap iframe {
        border: none;
    }

    .ml15 {
        margin-left: 0.8rem;
    }

    .operamini-tips {
        background: #FFFF00;
        text-align: center;
        font-weight: bold;
    }

    :root {
        color-scheme: light dark;
    }
    @media (prefers-color-scheme: dark) {
        .tabWrap {
            border-bottom: .1rem solid #111;
            background: #1c1c1c;
            span {
                color: #d5d5d5;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// AppMatchDetail.vue?e78fce04